<div class="container mt-4">
  <ngb-alert
    *ngIf="alert"
    [type]="alert.type"
    (closed)="closeAlert()"
    class="sticky-top"
    style="top: 10px"
    >{{ alert.message }}</ngb-alert
  >
  <app-register-stepper
    [progressData]="getProgressData()"
    [user]="user"
  ></app-register-stepper>

  <div class="row mb-2 account-detail-container">
    <div class="col-12">
      <div class="row mb-3">
        <div class="col-12 d-flex align-items-center justify-content-center">
          <h1 class="text-center">Free pet insurance from <strong>Petplan</strong><sup style="font-size: 16px;">&reg;</sup></h1>
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-12 position-relative">
      <div class="cover-for-banner"></div>
      <img [src]="bannerImagePath" class="petplan-image" alt="petplan-banner"/>
    </div>
  </div>

  <div class="row main-top">
    <div class="col-md-10 offset-md-1">
      <div class="d-flex justify-content-center">
        <h3 class="mt-5 mb-4 text-center">
          You are eligible for <span class="blue-text">4 weeks free</span> Petplan insurance for {{eligiblePet.name}}
        </h3>
      </div>
      <p class="mb-1 text-center small-text">
        Petplan will confirm how to activate your 4 weeks free cover, which provides instant protection for illness and injury.
      </p>
      <p class="mb-0 mt-4 text-center medium-text">
        Are you happy for us to share your details with Petplan?
      </p>
      <div class="button-container">
        <div
          class="my-4 d-flex flex-row justify-content-md-start align-items-center ms-2 button-container-content"
        >
          <button
            class="badge yes-button text-white"
            id="{{ petSpecie + '-Yes'}}"
            type="button"
            (click)="completeWelcomeGift(true)"
          >
            <b>Yes</b>, I would like 4 weeks free insurance
          </button>
        </div>
        <div
          class="mt-0 d-flex flex-row justify-content-start justify-content-md-start align-items-center ms-2 button-container-content"
        >
          <button
            class="badge no-button text-white"
            type="button"
            id="{{ petSpecie + '-No'}}"
            (click)="noToPetInsurance()"
          >
            <b>No</b>, I don't want free pet insurance
          </button>
        </div>
      </div>
      <p class="mb-5 mt-4 text-center small-text">
        You will only be contacted about free insurance and other options available to you within the next 14 days.
      </p>
    </div>
  </div>

  <div class="row mt-3 petplan-text">
    <div class="col-md-10 offset-md-1">
      <h4 class="mb-2 text-center">Why take out <span class="blue-text" >Petplan's</span> Free 4 Weeks Veterinary cover?</h4>
      <div class="bottom-box-container mt-4">
        <div class="bottom-box">
          <div class="bottom-box-header">Hassle-free claims</div>
          <div class="bottom-box-content">
            Petplan can pay your vet directly. Petplan pay 90% of claims in 5 working days.
          </div>
        </div>
        <div class="bottom-box">
          <div class="bottom-box-header">97% of claims paid</div>
          <div class="bottom-box-content">
            Petplan pay over £5 million in claims every week to help pets get the veterinary treatment they need.
          </div>
        </div>
        <div class="bottom-box">
          <div class="bottom-box-header">No penalty for claiming</div>
          <div class="bottom-box-content">
            Petplan’s Claims Pricing Guarantee means they’ll never charge you more for claiming.
          </div>
        </div>
      </div>
    </div>
    <div class="col-12 text-center mt-4">
      <div class="note me-sm-1 me-md-5">
        Petplan claims data correct since 2021
      </div>
    </div>
  </div>
  <div class="row mt-5 mb-4">
    <div class="col-12 text-center ">
      <div class="note">
        Terms, conditions and excesses apply. Excesses apply to veterinary fees
        treatment only: dog: £100, cats: £85, rabbit: £60. This insurance
        doesn’t cover any treatment for pre-existing conditions.
        <br>
        Petplan will pay a 10% commission which is a percentage of your annual premium when you take out or renew your policy.
        <br>
        Petplan® is a trading name of Pet Plan Limited (Registered in England No. 1282939) and Allianz Insurance plc (Registered in England No. 84638). Registered office: 57 Ladymead,
        Guildford, Surrey GU1 1DB. Pet Plan Limited is authorised and regulated by the Financial Conduct Authority. Allianz Insurance plc is authorised by the Prudential Regulation Authority and
        regulated by the Financial Conduct Authority and the Prudential Regulation Authority. Identicare Limited is an Appointed Representative of Pet Plan Limited and is not part of the Allianz (UK) Group.
        <br>
        This promotion is for pets who are currently not insured with Petplan.
      </div>
    </div>
  </div>
</div>
